<template>
  <div class="pay-page">
    <div class="top-wrap">
      <div class="top-blue">
        <h1 class="top-title">向商家支付</h1>
      </div>
      <div class="logo-card">
        <img
          class="logo-img"
          :src="require('@/assets/payment/cgm medical.png')"
          alt="CGM Medical"
        />
      </div>
    </div>

    <main class="main">
      <section class="sheet sheet--field">
        <div class="field-label">支付金额</div>
        <div class="field-row">
          <img
            class="field-ic"
            :src="require('@/assets/payment/input.png')"
            alt=""
          />
          <input
            v-model="amountInput"
            class="field-input"
            type="number"
            inputmode="decimal"
            min="0"
            step="0.01"
            placeholder="00.00"
          />
          <span class="field-unit">元</span>
        </div>
      </section>

      <section class="sheet sheet--field">
        <div class="field-label">赏小费</div>
        <div class="field-row">
          <img
            class="field-ic"
            :src="require('@/assets/payment/input.png')"
            alt=""
          />
          <input
            v-model="tipInput"
            class="field-input"
            type="number"
            inputmode="decimal"
            min="0"
            step="0.01"
            placeholder="00.00"
          />
          <span class="field-unit">元</span>
        </div>
      </section>

      <section class="sheet sheet--total">
        <span class="total-label">实际金额</span>
        <span class="total-value">¥{{ formattedTotal }} 元</span>
      </section>

      <section class="method-panel">
        <h2 class="method-title">请选择支付方式</h2>

        <button
          type="button"
          class="method-row"
          :class="{ 'method-row--on': paySelect === '2' }"
          @click="paySelect = '2'"
        >
          <img
            class="method-logo"
            :src="
              paySelect === '2'
                ? require('@/assets/payment/wechat.png')
                : require('@/assets/payment/wechat gray.png')
            "
            alt=""
          />
          <span class="method-name">微信</span>
          <img
            v-if="paySelect === '2'"
            class="method-choice"
            :src="choicePng"
            alt=""
          />
          <img
            v-else
            class="method-choice"
            :src="noChoicePng"
            alt=""
          />
        </button>

        <button
          type="button"
          class="method-row"
          :class="{ 'method-row--on': paySelect === '1' }"
          @click="paySelect = '1'"
        >
          <img
            class="method-logo"
            :src="
              paySelect === '1'
                ? require('@/assets/payment/ali.png')
                : require('@/assets/payment/ali gray.png')
            "
            alt=""
          />
          <span class="method-name">支付宝</span>
          <img
            v-if="paySelect === '1'"
            class="method-choice"
            :src="choicePng"
            alt=""
          />
          <img
            v-else
            class="method-choice"
            :src="noChoicePng"
            alt=""
          />
        </button>

        <button
          type="button"
          class="method-row"
          :class="{ 'method-row--on': paySelect === '3' }"
          @click="paySelect = '3'"
        >
          <img
            class="method-logo"
            :src="
              paySelect === '3'
                ? require('@/assets/payment/union.png')
                : require('@/assets/payment/union gray.png')
            "
            alt=""
          />
          <span class="method-name">银联</span>
          <img
            v-if="paySelect === '3'"
            class="method-choice"
            :src="choicePng"
            alt=""
          />
          <img
            v-else
            class="method-choice"
            :src="noChoicePng"
            alt=""
          />
        </button>
      </section>

      <button
        type="button"
        class="pay-bar"
        :disabled="loading"
        @click="goPay"
      >
        <span v-if="loading" class="pay-bar__loading">请求中…</span>
        <template v-else>
          <span class="pay-bar__inner">
            <img class="pay-bar__icon" :src="cgmPayPng" alt="" />
            <span class="pay-bar__txt">支付</span>
          </span>
        </template>
      </button>
    </main>
  </div>
</template>

<script>
export default {
  name: "Payment",
  data() {
    return {
      amountInput: "",
      tipInput: "",
      paySelect: "2",
      loading: false,
    };
  },
  computed: {
    choicePng() {
      return require("@/assets/payment/choice.png");
    },
    noChoicePng() {
      return require("@/assets/payment/no choice.png");
    },
    cgmPayPng() {
      return require("@/assets/payment/cgm pay.png");
    },
    totalYuan() {
      const base = this.parseYuan(this.amountInput);
      const tip = this.parseYuan(this.tipInput);
      return Math.round((base + tip) * 100) / 100;
    },
    formattedTotal() {
      const t = this.totalYuan;
      if (t <= 0) {
        return "0.00";
      }
      return t.toLocaleString("zh-CN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  methods: {
    parseYuan(s) {
      const n = parseFloat(String(s).trim());
      return Number.isFinite(n) && n >= 0 ? n : 0;
    },
    goPay() {
      const payTypeMap = {
        1: "alipay",
        2: "wechatpay",
        3: "unionpay",
      };
      const payType = payTypeMap[String(this.paySelect)] ?? "";
      const amountParam = this.totalYuan.toFixed(2);

      this.loading = true;
      this.axios
        .get("/nihaopay/submitSecurePay", {
          params: { rmbAmount: amountParam, payType },
        })
        .then((response) => {
          if (response.data.code !== 0) {
            this.$message.error(response.data.message || "支付请求失败");
            return;
          }
          const html = response.data.data;
          if (html) {
            const w = window.open("", "_self");
            w.document.write(html);
          } else {
            this.$message.error("支付响应数据格式错误");
          }
        })
        .catch(() => {
          this.$message.error("网络异常，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* Figma 1479:2「向商家支付」— 紧凑稿面约 340 宽 */
$blue: #1161ba;
$page-bg: #f5f6f7;
$text: #000000;
$muted: #cacaca;
$panel-from: #eef6ff;

.pay-page {
  min-height: 100vh;
  // max-width: 340px;
  margin: 0 auto;
  background: $page-bg;
  font-family: "PingFang SC", "PingFang HK", "Microsoft YaHei", -apple-system,
    BlinkMacSystemFont, sans-serif;
  padding-bottom: calc(18px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.top-wrap {
  position: relative;
  margin-bottom: 12px;
}

.top-blue {
  height: 128px;
  background: $blue;
  padding: calc(8px + env(safe-area-inset-top)) 10px 0;
  box-sizing: border-box;
  position: relative;
}

.top-title {
  margin: 0;
  padding-top: 6px;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.875;
  color: #ffffff;
}

.logo-card {
  margin: -52px 8px 0;
  height: 70px;
  background: #ffffff;
  border-radius: 9px;
  box-shadow: 0 3px 22px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.logo-img {
  max-width: 156px;
  max-height: 22px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.main {
  padding: 0 8px;
}

.sheet {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 3px 22px rgba(0, 0, 0, 0.05);
  margin-bottom: 12px;
}

.sheet--field {
  min-height: 82px;
  padding: 12px 26px 14px;
  box-sizing: border-box;
}

.field-label {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5625;
  color: $text;
  margin-bottom: 8px;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 7px;
}

.field-ic {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  object-fit: contain;
}

.field-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: $text;
  text-align: left;
  outline: none;
}

.field-input::placeholder {
  color: $muted;
}

.field-unit {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: $text;
}

.sheet--total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 26px;
  box-sizing: border-box;
  margin-bottom: 12px;
}

.total-label {
  font-size: 14px;
  font-weight: 600;
  color: $text;
}

.total-value {
  font-size: 17px;
  font-weight: 600;
  line-height: 1.4;
  color: $blue;
}

.method-panel {
  border-radius: 22px;
  background: linear-gradient(
    180deg,
    $panel-from 0%,
    #ffffff 16%,
    #ffffff 100%
  );
  box-shadow: 0 3px 22px rgba(0, 0, 0, 0.05);
  padding: 8px 12px 16px;
  margin-bottom: 14px;
}

.method-title {
  margin: 0 0 14px 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.875;
  color: $text;
}

.method-row {
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 60px;
  margin-bottom: 10px;
  padding: 0 14px 0 18px;
  box-sizing: border-box;
  border: 1px solid transparent;
  border-radius: 16px;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  transition: background 0.2s, border-color 0.2s;

  &:last-of-type {
    margin-bottom: 0;
  }
}

.method-row--on {
  background: $panel-from;
  border-color: $blue;
}

.method-logo {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex-shrink: 0;
}

.method-name {
  flex: 1;
  margin-left: 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.875;
  color: $text;
}

.method-choice {
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}

.pay-bar {
  width: calc(100% - 10px);
  max-width: 370px;
  margin: 0 auto 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 47px;
  border: none;
  border-radius: 9px;
  background: $blue;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  font-family: "PingFang HK", "PingFang SC", "Microsoft YaHei", sans-serif;
  cursor: pointer;
  box-sizing: border-box;

  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
  }
}

.pay-bar__inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.pay-bar__icon {
  width: 100px;
  height: 30px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}

.pay-bar__txt {
  letter-spacing: 0.02em;
}

.pay-bar__loading {
  font-weight: 500;
  font-size: 13px;
}

.fine-print {
  margin: 0 8px;
  font-size: 11px;
  line-height: 1.5;
  color: #8a93a3;
  text-align: center;
}
</style>
